import React from 'react'

import { useGlobalContext } from '../context'
import players from '../data' 

function Player() {
    const { addToCart, page } = useGlobalContext();
    let limits = [parseInt(page)*8 - 8, parseInt(page)*8]
    return (
        <React.Fragment>
            {   
                players.slice(limits[0],limits[1]).map((player, index) => {
                    return (
                        <div key={index} className={`col-md-3 mb-3 ${player.visibility ? "" : "hidden"}`}>
                            <div className="card ">
                                <div className="img-container">
                                    <img src={`./img/${player.path}.png`} className="medium card-img-top store-img img-fluid" alt="xx"/>
                                </div>
                                <div className="card-body">
                                    <div className="card-text d-flex justify-content-between text-capitalize">
                                        <span className="store-item-icon"> <i onClick={addToCart} className="fas fa-shopping-cart"></i></span>
                                        <h6 id="store-item-name">{player.name}</h6>
                                        <h6 className="store-item-value">$ <strong id="store-item-price" className="font-weight-bold">{player.price}</strong></h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })
            }
        </React.Fragment>
    )
}

export default Player